import React from 'react';
import ViewMessage from '@components/ViewMessage';
import { NavPeopleIcon } from '@repo/icons';

export default function MissingContact() {
  return (
    <ViewMessage
      icon={<NavPeopleIcon color="textPrimary" width="20" height="20" />}
      headline="Profile not found"
      message={
        <>
          The profile you requested
          <br />
          could not be found
        </>
      }
    />
  );
}
